import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";

import { useLabelPrinter } from "../../components/labels";
import { useLabelTemplates } from "../../components/labels/labelTemplates";
import ErrorDialog from "../../components/notifications/errorDialog/ErrorDialog";
import { ProgressDialog } from "../../components/notifications/progressDialog/progressDialog";

import { api } from "../../logic/api";

import { SessionContext } from "../../utility/useSession";
import { useDate } from "../../utility/useDate";

import TextInputField from "../../components/editable/EditableField/fields/TextInputField";
import NumberInputField from "../../components/editable/EditableField/fields/NumberInputField";
import AlertDialog from "../../components/notifications/alertDialog/AlertDialog";
import { useTranslation } from "react-i18next";

const BarrierTokenPrinter = () => {
    const { labelPrinter } = useLabelPrinter();
    const session = useContext(SessionContext);
    const createToken = api.hooks.processes.createBarrierAccessToken();
    const { localizeDate } = useDate();
    const { generateBarrierTokenPrintJob } = useLabelTemplates();
    const [showDialog, setShowDialog] = useState(false);
    const [showErrDialog, setShowErrDialog] = useState(false);
    const [err, setErr] = useState("");
    const [showCompletedAlert, setShowCompletedAlert] = useState(false);
    const [reason, setReason] = useState("");
    const [qty, setQty] = useState(1);
    const { t } = useTranslation();


    useEffect(() => {
        if (labelPrinter.err != null) {
            setErr(`${labelPrinter.err}`);
            setShowErrDialog(true);
        }

    }, [labelPrinter.err]);

    let printCount = 0;
    const printTokens = () => {
        printCount = 0;
        createTokens();
    }
    const createTokens = () => {
        if (printCount == qty) {
            printCount = 0;
            setShowDialog(false);
            if (labelPrinter.err == null) {
                setShowCompletedAlert(true);
            }

            return;
        }
        createToken.send(session.current.context, {
            reason: reason,
            requestDate: localizeDate(new Date()).toISO() ?? ""
        }, (result) => {
            if (result == null) {
                printCount = 0;
                return;
            }
            labelPrinter.print(generateBarrierTokenPrintJob(result.token), () => {
                printCount += 1;
                createTokens();
            });
        });
    }

    return (
        <div>
            <ProgressDialog status={createToken.status} />
            <ErrorDialog err={createToken.err} />
            <div style={{ paddingRight: 40, paddingTop: 40, textAlign: "right" }}>
                <Button
                    variant="contained"
                    color="secondary"
                    onClick={() => {
                        setReason("");
                        setQty(1);
                        setShowDialog(true);
                    }}
                    data-testid="settings-create-barrier-token-button"
                >
                    {t("settings.createBarrierToken")}
                </Button>
            </div>
            <Dialog
                open={showDialog}

                aria-labelledby="alert-dialog-slide-title"
                aria-describedby="alert-dialog-slide-description"
            >
                <DialogTitle id="alert-dialog-slide-title">{t("settings.createBarrierToken")}</DialogTitle>
                <DialogContent>
                    <div style={{ paddingTop: 10, }}>
                        <TextInputField multiLine={true} label={"Reason"} value={reason} onChange={(value) => {
                            setReason(value);
                        }} data-testid="settings-create-barrier-token-reason-field" />
                    </div>
                    <div style={{ paddingTop: 10 }}>
                        <NumberInputField label={"Quantity"} value={qty} onChange={(value) => {
                            if (!isNaN(value)) {
                                setQty(value);
                            }
                        }} data-testid="settings-create-barrier-token-quantity-field" />
                    </div>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setShowDialog(false)} color="secondary" data-testid="settings-create-barrier-token-cancel-button">{t("general.cancel")}</Button>
                    <Button disabled={reason.length == 0 || qty < 1} onClick={() => printTokens()} color="primary" data-testid="settings-create-barrier-token-print-button" >{t("input.labels.print")}</Button>
                </DialogActions>
            </Dialog>
            <AlertDialog
                title={t("settings.barrierTokens")}
                message={t("settings.barcodePrinted", { count: printCount })}
                show={showCompletedAlert}
                onClose={() => {
                    setShowCompletedAlert(false);
                }}
                data-testid="settings-create-barrier-token-completed-alert"
            ></AlertDialog>
            <AlertDialog
                title={t("kmos.labels.error")}
                message={err}
                show={showErrDialog}
                onClose={() => {
                    setShowErrDialog(false);
                }}
                data-testid="settings-create-barrier-token-error-alert"
            ></AlertDialog>
        </div>
    );
}

export default BarrierTokenPrinter;
